export const _emailRegex_ = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
export const _mobileNumberRegex_ = /^[6-9]\d{0,9}$|^$/
export const _alphabetRegex_ = /^[a-zA-Z]*$/
export const _alphabetSpaceRegex_ = /^[a-zA-Z\s]+$/
export const _numberRegex_ = /^\d+\.?\d*$|^$/
export const _firmwareVersionRegex_ = /^\d+(\.\d*)*$|^$/
export const _latitudeRegex_ =
  /^(\+|-)?(?:90(?:\.0{1,20})?|[1-8]?\d(?:\.\d{1,20})?)$/
export const _longitudeRegex_ =
  /^(\+|-)?(?:180(?:\.0{1,20})?|1[0-7]\d(?:\.\d{1,20})?|[1-9]?\d(?:\.\d{1,20})?)$/
